import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {isEditing} from '@builder.io/sdk-react'
import {useDebounce} from '@uidotdev/usehooks'
import {defaultPopoverTrigger, defaultPopoverContent} from './utils'
import {Popover} from '@/components/ui/popover'
import {PopoverContext} from './popoverContext'

export const PopoverContainer = ({children}) => {
    const isEdit = isEditing()
    const [popoverOpen, setPopoverOpen] = useState(false)

    const debouncedOpen = useDebounce(popoverOpen, 200)

    const handleMouseLeave = () => {
        const firstDrawer = document.querySelector('div[data-vaul-drawer]')
        if (firstDrawer) return
        setPopoverOpen(false)
    }

    useEffect(() => {
        const handleDrawerClose = () => {
            setPopoverOpen(false)
        }

        document.addEventListener('closeDrawer', handleDrawerClose)

        return () => {
            document.removeEventListener('closeDrawer', handleDrawerClose)
        }
    }, [])

    const enablePopover = !isEdit
    return (
        <PopoverContext.Provider
            value={{
                popoverOpen,
                setPopoverOpen: enablePopover ? setPopoverOpen : () => {},
                handleMouseLeave
            }}
        >
            <Popover
                open={debouncedOpen}
                onOpenChange={setPopoverOpen}
                data-testid="popoverContainer-Popover"
            >
                {children}
            </Popover>
        </PopoverContext.Provider>
    )
}

PopoverContainer.propTypes = {
    children: PropTypes.node
}

export const PopoverContainerDefinition = {
    component: PopoverContainer,
    name: 'v1: Popover',
    noWrap: true,
    canHaveChildren: true,
    defaultChildren: [defaultPopoverTrigger, defaultPopoverContent]
}
